import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import useSystemSettings from '../hooks/useSystemSettings';

function DashboardLayout({
  title,
  breadcrumbs = [],
  profile,
  activeMenu = 'dashboard',
  children,
}) {
  const [collapsed, setCollapsed] = useState(false);
  const [showCriteria, setShowCriteria] = useState(true);
  const { settings } = useSystemSettings();

  return (
    <div className="layout-shell">
      <Sidebar
        profile={profile}
        settings={settings}
        collapsed={collapsed}
        showCriteria={showCriteria}
        setShowCriteria={setShowCriteria}
        activeMenu={activeMenu}
      />

      <div className="layout-main">
        <Topbar
          title={title}
          breadcrumbs={breadcrumbs}
          profile={profile}
          settings={settings}
          onToggleSidebar={() => setCollapsed((prev) => !prev)}
        />

        <main className="layout-content">{children}</main>

        <footer className="layout-footer">
          {settings.footer_text}
        </footer>
      </div>
    </div>
  );
}

export default DashboardLayout;
